const socketTypes = {
  CONNECT: 'CONNECT',
  DISCONNECT: 'DISCONNECT',
};

export default socketTypes;
